export default __webpack_public_path__ + "static/media/pyramid.542f82ed.png";